export default "__VITE_ASSET__Cq5L2KHU__"